import React from 'react';
// import './Dialog.css';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

class DialogS extends React.Component {
    constructor(props) {
        super(props);
        this.handleListItemClick = this.handleListItemClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.state = {
          onClose: this.props.onClose
        }
    }

    handleClose() {
      this.state.onClose(null);
    }
    
    handleListItemClick(value) {
      this.state.onClose(value);
    }

    render(){
        return (
            <Dialog onClose={this.handleClose} aria-labelledby="simple-dialog-title" open={this.props.open}>
              <DialogTitle id="simple-dialog-title">Choose user property</DialogTitle>
              <List>
                {this.props.properties.map(property => (
                  <ListItem button onClick={() => this.handleListItemClick(property)} key={property}>
                    <ListItemText primary={property} />
                  </ListItem>
                ))}
              </List>
            </Dialog>
          );
    }
}

export default DialogS;